import DocumentToolsItem from './DocumentToolsItem'

export default DocumentToolsItem
